module.exports = __webpack_public_path__ + "media/images/PHI-Interns-Presentation-new-65bd0ec88ceb229e6fa852d83f22ada4.jpeg";